import type { Except } from "type-fest";
import type { SwishNumber } from "./swish-number";

type SwishRefundRequest = {
    /**
     * Reference of the original payment that this refund is for
     * @type {"replace"}
     */
    originalPaymentReference: string;
    /**
     * URL that Swish will use to notify caller about the outcome of the refund. \
     * The URL has to use HTTPS
     * @type {string}
     */
    callbackUrl: string;
    /**
     * The Swish number of the merchant that makes the refund payment
     * @type {SwishNumber}
     */
    payerAlias: SwishNumber;
    /**
     * The amount of money to refund. The amount cannot be less than 1 SEK and not more than 999999999999.99 SEK. Moreover, the amount cannot exceed the remaining amount of the original payment that the refund is for \
     * Format: `100.00` (in SEK)
     */
    amount: number;
    /**
     * The currency to use. The only currently supported value is SEK. \
     * Format: `SEK`
     */
    currency: "SEK";
    /**
     * Payment reference supplied by the merchant. This could be order id or similar
     * @type {string}
     */
    payerPaymentReference?: string;
    /**
     * Merchant supplied message about the refund. Max 50 chars. Allowed characters are the letters a-ö, A-Ö, the numbers 0-9 and the special characters :;.,?!()”
     * @type {string}
     */
    message?: string;
};

const createSwishRefundRequest = (
    params: Except<SwishRefundRequest, "currency">,
): SwishRefundRequest => {
    return {
        ...params,
        currency: "SEK",
    };
};

export { createSwishRefundRequest };
export type { SwishRefundRequest };
